import React, { useState } from 'react';
import { BookOpen, ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Tomo {
  number: number;
  title: string;
  chapters: string[];
}
const tomos: Tomo[] = [{
  number: 1,
  title: 'Evaluación Inicial Profesional',
  chapters: ['La Primera Consulta: Qué información realmente importa', 'Anamnesis Nutricional Paso a Paso', 'Evaluación Antropométrica', 'Evaluación Clínica y Laboratorios', 'Detección de Barreras Ocultas', 'Perfil Psicoemocional del Paciente', 'Identificación de Hábitos Críticos', 'Jerarquización de Problemas', 'Definición de Objetivos SMART', 'Construcción del Caso Nutricional']
}, {
  number: 2,
  title: 'Casos Clínicos Resueltos',
  chapters: ['Paciente con Sobrepeso y Baja Adherencia', 'Paciente con Ansiedad Alimentaria', 'Paciente que No Baja de Peso', 'Paciente con Alimentación Emocional', 'Paciente Sedentario', 'Paciente con Poco Tiempo', 'Paciente Deportista Amateur', 'Paciente que Abandona Tratamientos', 'Paciente con Resistencia a la Insulina', 'Cómo Resolver Casos Complejos']
}, {
  number: 3,
  title: 'Sistemas de Intervención Nutricional',
  chapters: ['Cómo Diseñar un Plan Alimentario', 'Adherencia y Cambio de Hábitos', 'Manejo de Hambre y Saciedad', 'Intervención sobre Ansiedad', 'Educación Alimentaria Efectiva', 'Pacientes Difíciles', 'Manejo de Recaídas', 'Ajustes de Estrategia', 'Seguimiento Inteligente', 'Protocolos de Intervención']
}, {
  number: 4,
  title: 'Nutrición Deportiva Aplicada',
  chapters: ['Bases de Nutrición Deportiva', 'Deportes de Fuerza', 'Deportes de Resistencia', 'Timing Nutricional', 'Recuperación', 'Hidratación', 'Suplementación Basada en Evidencia', 'Planificación Nutricional', 'Casos Deportivos Reales', 'Errores Frecuentes']
}, {
  number: 5,
  title: 'Organización y Gestión del Consultorio',
  chapters: ['Sistema de Consultas', 'Gestión de Formularios', 'Seguimiento de Pacientes', 'Documentación Profesional', 'Organización de Casos', 'Automatización Básica', 'Indicadores de Seguimiento', 'Control de Adherencia', 'Prevención de Abandono', 'Sistema Completo de Trabajo']
}];
export function Tomos() {
  const [expandedTomo, setExpandedTomo] = useState<number | null>(null);
  const toggleTomo = (number: number) => {
    setExpandedTomo(expandedTomo === number ? null : number);
  };
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-271">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-273">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-274">
            📚 Lo que incluye el Megapack:{' '}
            <span className="text-emerald-600" data-id="element-275">5 Tomos profesionales</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto" data-id="element-276">
            Cada tomo está diseñado para que domines un área específica de tu
            práctica profesional
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-277">
          {tomos.map((tomo, index) => <motion.div key={tomo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-gradient-to-r from-emerald-50 to-white border-2 border-emerald-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-278">
              <button onClick={() => toggleTomo(tomo.number)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-emerald-50 transition-colors duration-200" data-id="element-279">
                <div className="flex items-center gap-4" data-id="element-280">
                  <div className="bg-emerald-600 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-281">
                    📘
                  </div>
                  <div data-id="element-282">
                    <div className="text-sm font-semibold text-emerald-700 mb-1" data-id="element-283">
                      TOMO {tomo.number}
                    </div>
                    <div className="text-xl md:text-2xl font-bold text-slate-900" data-id="element-284">
                      {tomo.title}
                    </div>
                  </div>
                </div>
                {expandedTomo === tomo.number ? <ChevronUp className="w-6 h-6 text-emerald-600 flex-shrink-0" data-id="element-285" /> : <ChevronDown className="w-6 h-6 text-emerald-600 flex-shrink-0" data-id="element-286" />}
              </button>

              <AnimatePresence data-id="element-287">
                {expandedTomo === tomo.number && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-288">
                    <div className="px-6 pb-6 pt-2" data-id="element-289">
                      <div className="bg-white rounded-xl p-6 border border-emerald-100" data-id="element-290">
                        <ol className="space-y-3" data-id="element-291">
                          {tomo.chapters.map((chapter, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-292">
                              <span className="text-emerald-600 font-bold flex-shrink-0" data-id="element-293">
                                {idx + 1}.
                              </span>
                              <span className="text-slate-700" data-id="element-294">{chapter}</span>
                            </li>)}
                        </ol>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}